import apiClient from "./axios.config";

const filterService = {
  submitLocality() {
    return apiClient.get("/website/locations");
  },
  getTypeOfWork() {
    return apiClient.get("/website/type-of-work");
  },
  filterServices(payload) {
    return apiClient.post("/website/service-listing", payload);
  },
  bookNowServices(serviceId) {
    return apiClient.post(`/website/service/${serviceId}`);
  },
};

export default filterService;
